// @flow
import { handleActions } from 'redux-actions';
import {
    ASK_FOR_CONFIRMATION, CLOSE, PROCEED, DEFAULT_MESSAGE,
} from './constants';


export type Confirmation = {
    +message: string,
};

export type Action = {
    +type: string,
    +payload: Object,
}

export type Path = {
    +url: string,
}

export type CategoryState = {
    +type: string,
    +data: Action | Path,
    +confirmation: Confirmation,
};

export type State = {
    [category: string]: Confirmation,
};

const initialState: State = {};

const reducer = handleActions({
    [ASK_FOR_CONFIRMATION]: (state: State, { payload }: {
        payload: {
            category: string,
            data: CategoryState,
        }
    }) => {
        const { category, data: { confirmation } } = payload;
        const newState = { ...payload.data };
        if (!confirmation || !confirmation.message) {
            newState.confirmation = {
                message: DEFAULT_MESSAGE,
            };
        }
        return {
            ...state,
            [category]: newState,
        };
    },
    [CLOSE]: (state: State, { payload }) => {
        const newState = { ...state };

        delete newState[payload];

        return newState;
    },
    [PROCEED]: (state: State, { payload }) => {
        const newState = { ...state };

        delete newState[payload.category];

        return newState;
    },
}, initialState);

export default reducer;
